<script setup>
import { useMenu } from "../../composables/useMenu.js";

defineProps({
  sortBy: { type: String, required: true },
  options: { type: Array, required: true }, // [{ key, label }]
});
const emit = defineEmits(["select"]);

const { isOpen, triggerEl, menuEl, menuStyle, toggle, close, onMenuKeydown } = useMenu();

function select(key) {
  close();
  emit("select", key);
}
</script>

<template>
  <div class="shrink-0" @click.stop>
    <button
      ref="triggerEl"
      class="flex items-center justify-center w-6 h-6 rounded text-slate-400 hover:bg-slate-200 dark:hover:bg-slate-700 border-0 bg-transparent cursor-pointer transition-colors"
      aria-haspopup="menu"
      :aria-expanded="isOpen"
      aria-label="Sort by"
      title="Sort by"
      @click="toggle"
    >
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
        <path d="M3 6h18M7 12h10M11 18h2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>

    <Teleport to="body">
      <div
        v-if="isOpen"
        ref="menuEl"
        role="menu"
        aria-label="Sort by"
        :style="menuStyle"
        class="w-40 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl shadow-xl py-1.5 z-[400] overflow-hidden"
        @keydown="onMenuKeydown"
      >
        <p class="text-[10px] font-semibold uppercase tracking-widest text-slate-400 dark:text-slate-500 px-3 pt-1 pb-1.5 m-0">Sort by</p>
        <button
          v-for="opt in options"
          :key="opt.key"
          role="menuitem"
          :class="sortBy === opt.key
            ? 'text-brand bg-orange-50 dark:bg-orange-950/30'
            : 'text-slate-700 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-700'"
          class="flex items-center w-full px-3 py-1.5 text-[13px] text-left border-0 bg-transparent cursor-pointer transition-colors"
          @click="select(opt.key)"
        >
          {{ opt.label }}
        </button>
      </div>
    </Teleport>
  </div>
</template>
